import React from 'react';
import { ReviewCard } from '../../components/ReviewCard';
import { STORM_REVIEWS } from '../../components/realReviews';
const FEATURED_REVIEW_NAMES = ['Kimberly Torres', 'Mike Seibert', 'Isha Shah', 'Marquita Harris', 'David Bushman', 'Neelam Jagani'];
export function FreeTrialReviews() {
  const reviews = STORM_REVIEWS.filter(r => FEATURED_REVIEW_NAMES.includes(r.name));
  return <section className="py-24 bg-off-white" data-id="element-1575">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1576">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1577">
          <div className="inline-flex items-center gap-2 text-storm-red font-bold mb-3" data-id="element-1578">
            <span className="text-gold tracking-widest" data-id="element-1579">★★★★★</span>
            <span data-id="element-1580">5.0 Rating From 201 Reviews</span>
          </div>
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1581">
            Real Parent Reviews
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-1582">
            These are real Storm families speaking in their own voice. No stock
            testimonials.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1583">
          {reviews.map(r => <ReviewCard key={r.name} quote={r.quote} name={r.name} label={r.label} data-id="element-1584" />)}
        </div>
      </div>
    </section>;
}